export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_2.1-10d6f9df86489af8b4d6f414061efd29.svg";